/* steve2ControlAppNav.js */

"use strict";

const CAN = require("./ControlAppNavAddon");
const SteveRouter = require("@gluenetworks/steve_core_router");
const _ = require("lodash");
const SOLUTION_USER_PERM_MAP = require("../SolutionPermsMap");
const GSO_ID = "565a65db-54e7-4461-a954-f0f38f310e19";

class OldControlAppNav extends CAN {
    constructor(
        log,
        userSession,
        userFeedback,
        router,
        localStorage,
        solnMan,
        StorageFactory,
        ControlUser,
        ActionGroup,
        OsUpgradePlanPrefs,
        GenAIGluwareService,
        SystemConfigEntityDef,
        VersionControlConfig,
        DataSyncConfig,
        GenAiConfig
    ) {
        // Create a stub for steve.user.preferences._regStorage to prevent errors during homebar construction
        // when preferences aren't loaded yet. We don't queue operations because they would be based on
        // stub data (empty arrays, nulls) and would overwrite real preferences when replayed.
        // Instead, we just silently succeed and let preferences be loaded properly after authentication.
        // eslint-disable-next-line no-undef
        const originalPreferences = steve.user.preferences;

        // eslint-disable-next-line no-undef
        steve.user.preferences = {
            _regStorage: {
                setValue: (key, value) => {
                    // Silently succeed - don't save stub-generated values
                    return Promise.resolve();
                },
                getValue: (key) => {
                    // Return null during construction, real values loaded after authentication
                    return null;
                },
            },
        };

        super(
            log,
            userSession,
            userFeedback,
            router,
            localStorage,
            solnMan,
            StorageFactory,
            ControlUser,
            ActionGroup,
            OsUpgradePlanPrefs,
            GenAIGluwareService,
            SystemConfigEntityDef,
            VersionControlConfig,
            DataSyncConfig,
            GenAiConfig
        );

        // Restore original preferences object and assign to this._steve
        // eslint-disable-next-line no-undef
        steve.user.preferences = originalPreferences;
        // eslint-disable-next-line no-undef
        this._steve = steve;
        this._controlUser = undefined;
        this._getEncodedRouteData = this._getEncodedRouteData.bind(this);
        this._setControlUserEntity = _.debounce(this._setControlUserEntity.bind(this), 500);
        this._setInitialValuesOnHomeBar = _.debounce(
            this._setInitialValuesOnHomeBar.bind(this),
            500
        );
        this._routeToLogin = _.debounce(this._routeToLogin.bind(this), 700);
    }

    _registerSolutionChangeListener() {
        this._router.on(
            "sectionChanged",
            (this._onSectionChanged = this._onSectionChanged.bind(this))
        );
    }

    _onSectionChanged(sectionName) {
        document.title = _.get(this._section_titles, sectionName, this._section_titles.default);

        this.updateHomebarIoT();
    }

    _onHomeBarRequestedNavigateToDashboard() {
        this.emit("ShutdownCurrentSection");
        this.routeToDashboard();
    }

    _routeToLogin() {
        // let routeDetails = {};
        // // window.sessionStorage.setItem(this._userSession.token+"isBannerAccepted", false);
        // // this._setUrl();
        // let rdStr = JSON.stringify(routeDetails);
        // let encodedRouteData = this._steve.util.b64EncodeUnicode(rdStr);
        const token = this._userSession.token || this._localStorage.getToken();
        localStorage.clear();
        location.href = `${window.origin}/session/logout/${token}`;
    }

    _setHomebarUserImage(user) {
        // organizationId
        // userId, actionGroupId
        return this._ControlUserEntity.loadControlUser(user.organizationId, user.userId);
    }

    _setHomebarRole(userEntity) {
        return this._ActionGroupEntity
            .loadAscendActionGroup(userEntity.organizationId, userEntity.actionGroupId)
            .then((group) => {
                return this._homebar.setRole(group.properties.name);
            });
    }

    getUserPreferences() {
        const activeOrgId = _.get(this._userSession.activeOrganization, "id");
        return this._OsUpgradePlanPrefs.loadPrefs(activeOrgId).then((OsUpgradePlanPrefs) => {
            this._isCatalogEnable = OsUpgradePlanPrefs.getProperty("enableCatalogs");
            this._homebar.setIsCatalogEnabled(this._isCatalogEnable);
            return Promise.resolve();
        });
    }

    _setInitialValuesOnHomeBar() {
        this._homebar.emitInitialValues();
    }

    _onAuthenticated(userInfo) {
        this._homebar.setUserData(userInfo);

        const ConnectionHandlerFactory = require("@gluenetworks/platform-sdk-remote")
            .connectionFactories.ConnectionHandlerFactory;
        const connection = ConnectionHandlerFactory.getInstance();

        const genAIGluwareService = new this._genAiServiceIns(connection);
        this._homebar.setGenAIGluwareService(genAIGluwareService);

        const orgFromStorage = this._steve.user.preferences._regStorage.getValue(
            "system.core.activeOrganization"
        );

        const themeFromStorage =
            this._steve.user.preferences._regStorage.getValue("user.theme") || false;

        //user theme variable injection
        if (themeFromStorage) {
            let style = document.createElement("style");
            const themeExplorer = themeFromStorage.explorer.value;
            const hover = themeExplorer.colors.hover;
            const selected = themeExplorer.colors.selected;

            style.innerHTML = `:root { --hover: ${hover}; --selected: ${selected}; }`;
            document.getElementsByTagName("head")[0].appendChild(style);
        }

        this._localStorage.setUserId(userInfo.userId);
        this._localStorage.setToken(this._userSession.token);

        this._homebar.setUserId(userInfo.userName);
        this._homebar.setName(userInfo.first + " " + userInfo.last, [
            userInfo.first,
            userInfo.last,
        ]);
        this._homebar.setEmail(userInfo.email);
        this._setHomebarUserImage(userInfo)
            .then((controlUser) => {
                this._controlUser = controlUser;
                this._homebar.setUserImage(controlUser.properties.image);
                this._setControlUserEntity();
                return Promise.resolve();
            })
            .then(() => {
                this._homebar.setAIChat();
                return Promise.resolve();
            })
            .then(() => {
                return this.getUserPreferences();
            })
            .then(() => {
                this._homebar._buildVerticalMenuStart();
                return Promise.resolve();
            });
        this._setHomebarRole(userInfo);
        let orgOptions = [];
        Object.keys(userInfo.authorizedOrganizations).forEach((orgId) => {
            const org = userInfo.authorizedOrganizations[orgId];
            const name = _.get(org, "name");
            const description = _.get(org, "description", name);
            orgOptions.push({label: name, value: {id: orgId, name: name}, description});
        });

        this.setOrganizations(orgOptions);
        let orgToBeSelected = {};
        if (userInfo.authorizedOrganizations[userInfo.organizationId]) {
            orgToBeSelected = {
                name: userInfo.authorizedOrganizations[userInfo.organizationId].name,
                id: userInfo.organizationId,
            };
        } else {
            orgToBeSelected = orgOptions[0];
        }

        let routeData = this._router.getRouteData();
        if (_.isUndefined(routeData)) {
            routeData = {};
        }
        if (_.has(routeData, "activeOrganization")) {
            if (userInfo.authorizedOrganizations[routeData.activeOrganization.id]) {
                orgToBeSelected = routeData.activeOrganization;
            }
        } else {
            let storedOrg = this._localStorage.getActiveOrganization();
            if (storedOrg && storedOrg.id && userInfo.authorizedOrganizations[storedOrg.id]) {
                orgToBeSelected = storedOrg;
            } else {
                let orgId = Object.keys(userInfo.authorizedOrganizations)[0];
                orgToBeSelected = {
                    name: userInfo.authorizedOrganizations[orgId].name,
                    id: orgId,
                };
            }
        }

        if (orgFromStorage) {
            orgToBeSelected = orgFromStorage.value ? orgFromStorage.value : orgFromStorage;
        }

        this._router.updateRouteInfo({routeData});
        this._userSession.setActiveOrganization(orgToBeSelected);
        this._homebar.setActiveOrganization(orgToBeSelected);

        this.updateHomebarVersionControl();
        this.updateHomebarIoT();
    }

    _setControlUserEntity() {
        this._homebar.setControlUser(this._controlUser);
    }

    _updateGenAiState() {
        const licenseRestriction = this._homebar && this._homebar.licenseRestriction;
        const licenseReady = licenseRestriction
            ? licenseRestriction.whenLicenseFeedIsReady()
            : Promise.resolve();

        return Promise.all([this._loadGenAiConfigs(), licenseReady])
            .then(([[systemConfig, genAiConfig]]) => {
                return this._setGenAiVisibilityAndEnablement(
                    systemConfig,
                    genAiConfig,
                    this._homebar.getUserAuthorizedActions()
                );
            })
            .catch((err) => {
                this._logger.error(
                    {error: err},
                    err,
                    "ControlAppNavAddon: _updateGenAiState - Cannot refresh GenAI state"
                );
            });
    }

    _onConnectionLost() {
        console.log("steve2ControlAppNav._onConnectionLost -> redirecting to FailComms");
        // Briefly introduced for case 24383 -- Must be revisited
        // this._steve.controlAppNav.hideHomebar();
        const routeInfo = this._router.getRouteInformation();
        if (_.get(routeInfo, "sectionName") !== "FailComms") {
            this._router.goTo("FailComms", {routeData: {redirect: routeInfo}});
        }
    }

    _getCurrentSection() {
        let routeInfo = this._router.getRouteInformation();
        return _.get(routeInfo, "sectionName");
    }

    _onHomeBarRequestedHelp() {
        const newSteveRouter = new SteveRouter(window, window.history);
        this._homebar.blur();
        let solnHelpLink = _.get(this._solutionManager.activeSolution, "helpLink", null);

        newSteveRouter.navigateToHelpTab(
            {app: "GameConsole", s: "RoboHelp", sln: solnHelpLink},
            "robohelp"
        );
    }

    setOrganizations(orgOptions) {
        this._homebar.setOrganizations(
            orgOptions.sort((a, b) => {
                let nameA = a.label.toUpperCase(); // ignore upper and lowercase
                let nameB = b.label.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                // names must be equal
                return 0;
            })
        );
    }

    routeToDashboard() {
        window.location =
            window.origin + "/#!/_app_/GameConsole/_s_/Dashboard/_rd_/JTdCJTdE/_ra_/dashboard";
    }

    routeToLicensing() {
        const encodedRouteData = this._getEncodedRouteData();
        window.location =
            window.origin +
            "/#!/_app_/GameConsole/_s_/Settings/_sln_/Settings/_rd_/" +
            encodedRouteData +
            "/_sr_/Organization/Licensing";
    }

    reRouteUser(authorizedActions) {
        if (authorizedActions.includes(SOLUTION_USER_PERM_MAP.dashboard)) {
            window.location = window.origin + "/#!/_app_/GameConsole/_s_/Dashboard";
        } else if (authorizedActions.includes(SOLUTION_USER_PERM_MAP.DeviceManager)) {
            window.location =
                window.origin + "/#!/_app_/GameConsole/_s_/GameCenter/_sln_/DeviceManager";
        } else {
            window.location =
                window.origin +
                "/#!/_app_/GameConsole/_s_/Settings/_sln_/Settings/_sr_/User/EditMyProfile";
        }
    }

    _getEncodedRouteData() {
        let routeDetails = {
            activeOrganization: this._steve.user.preferences.core.activeOrganization,
        };
        let rdStr = JSON.stringify(routeDetails);
        return this._steve.util.b64EncodeUnicode(rdStr);
    }
}

module.exports = OldControlAppNav;
